import React, { useState, useEffect } from 'react';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    grass: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,12.5A1.5,1.5 0 0,1 10.5,11A1.5,1.5 0 0,1 12,9.5A1.5,1.5 0 0,1 13.5,11A1.5,1.5 0 0,1 12,12.5M12,7.2C9.9,7.2 8.2,8.9 8.2,11C8.2,14.1 12,18.1 12,18.1C12,18.1 15.8,14.1 15.8,11C15.8,8.9 14.1,7.2 12,7.2Z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    build: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
      </svg>
    ),
    home: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"/>
      </svg>
    ),
    notifications: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    playArrow: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M8 5v14l11-7z"/>
      </svg>
    ),
    dollar: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"/>
      </svg>
    ),
    insights: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M7.5 14H10v-1H7.5v1zm0 3H10v-1H7.5v1zm0-6H10V9H7.5v2zm4.5 6h5v-1H12v1zm0-3h5v-1H12v1zm0-3h5V9H12v2zM7 18h14V6H7v12zM5 4v16h16V4H5z"/>
      </svg>
    ),
    park: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C8.36,20 8.86,19.87 9.34,19.7L10.29,22L12.18,21.34C10.1,16.17 8,10 17,8M17,10.5A2.5,2.5 0 0,0 14.5,13A2.5,2.5 0 0,0 17,15.5A2.5,2.5 0 0,0 19.5,13A2.5,2.5 0 0,0 17,10.5M17,3A4,4 0 0,0 13,7A4,4 0 0,0 17,11A4,4 0 0,0 21,7A4,4 0 0,0 17,3Z"/>
      </svg>
    ),
    water: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,3.77L11.25,4.61C11.25,4.61 9.97,6.06 8.68,7.94C7.39,9.82 6.25,12.07 6.25,14.33A5.75,5.75 0 0,0 12,20.08A5.75,5.75 0 0,0 17.75,14.33C17.75,12.07 16.61,9.82 15.32,7.94C14.03,6.06 12.75,4.61 12.75,4.61L12,3.77M12,6.9C12.44,7.42 12.84,7.85 13.68,9.07C14.89,10.83 15.75,12.33 15.75,14.33A3.75,3.75 0 0,1 12,18.08A3.75,3.75 0 0,1 8.25,14.33C8.25,12.33 9.11,10.83 10.32,9.07C11.16,7.85 11.56,7.42 12,6.9Z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const LandscapersLanding = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  // Waitlist form state
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'landscaping'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Lawn Maintenance",
      time: "Tuesday, 8:15 AM",
      customer: "Need weekly lawn service for my 0.5 acre property",
      response: "I can schedule a consultation for Thursday. Weekly lawn service for your property size typically runs $80-120 per visit.",
      outcome: "$95 weekly service",
      color: "blue"
    },
    {
      type: "Landscaping Design",
      time: "Friday, 3:30 PM",
      customer: "Want to redesign front yard with new plants and walkway",
      response: "I'd love to schedule a design consultation. Front yard redesigns typically range from $3,000-$8,000 depending on scope.",
      outcome: "$4,800 design project",
      color: "blue"
    },
    {
      type: "Tree Service", 
      time: "Monday, 7:45 AM",
      customer: "Large tree fell in backyard during storm, need removal",
      response: "I'm dispatching our tree service team now. Storm damage tree removal starts at $400 plus disposal fees.",
      outcome: "$850 tree removal",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Seasonal work used to be stressful. Now the AI books maintenance clients year-round and my schedule stays consistent.",
      author: "Carlos D.",
      business: "Verde Landscaping",
      result: "58% more maintenance clients"
    },
    {
      quote: "Design projects are my favorite work. The AI qualifies serious clients and I spend time creating, not chasing leads.",
      author: "Amanda K.", 
      business: "Bloom Design Studio",
      result: "$18,400 avg monthly increase"
    },
    {
      quote: "From weekly mowing to full landscape installs, the AI handles every type of call professionally.",
      author: "Michael T.",
      business: "Greenscape Solutions", 
      result: "Booked 3 weeks ahead"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'landscaping' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
      {/* Header */}
      <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="text-lg font-black text-blue-900">
            <a href="/">receptioneer.ai</a>
          </div>
          <div className="flex items-center gap-6">
            <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
              Try Live Demo
            </a>
            <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
              Login
            </button>
          </div>
        </div>
      </header>
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
          {/* Left Side - Content */}
          <div className="px-6 py-12 lg:py-20">
            <div className="inline-flex items-center bg-blue-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
              🌿 For Landscaping Professionals
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              Never Miss Another
              <br />
              <span className="text-blue-200">Landscaping Call</span>
            </h1>
            
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              From weekly maintenance to full landscape designs, your AI receptionist handles every call professionally. 
              <strong className="text-white">Quotes jobs, books consultations, and captures leads 24/7.</strong>
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get My Landscaping AI →
              </button>
              
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-blue-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Test It Live
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center">
                <div className="text-2xl font-black text-white">24/7</div>
                <div className="text-blue-200 text-sm">Landscaping calls</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-black text-white">$399</div>
                <div className="text-blue-200 text-sm">Per month</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-black text-white">24hrs</div>
                <div className="text-blue-200 text-sm">Setup time</div>
              </div>
            </div>
          </div>

          {/* Right Side - Call Examples */}
          <div className="bg-blue-800 lg:bg-transparent px-6 py-12 lg:py-20">
            <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
              {/* Live Call Simulation */}
              <div className="flex items-center gap-3 mb-6">
                <div className={`w-4 h-4 rounded-full animate-pulse ${
                  callExamples[currentCallType].color === 'red' ? 'bg-red-500' :
                  callExamples[currentCallType].color === 'green' ? 'bg-green-500' : 'bg-blue-500'
                }`}></div>
                <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
              </div>
              
              <div className="space-y-4 mb-6">
                <div className="bg-gray-50 rounded-lg p-3">
                  <div className="text-xs text-gray-600 font-semibold mb-1">Customer:</div>
                  <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                </div>
                
                <div className={`rounded-lg p-3 ${
                  callExamples[currentCallType].color === 'red' ? 'bg-red-50' :
                  callExamples[currentCallType].color === 'green' ? 'bg-green-50' : 'bg-blue-50'
                }`}>
                  <div className={`text-xs font-semibold mb-1 ${
                    callExamples[currentCallType].color === 'red' ? 'text-red-600' :
                    callExamples[currentCallType].color === 'green' ? 'text-green-600' : 'text-blue-600'
                  }`}>AI Response:</div>
                  <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                </div>
              </div>
              
              <div className="text-center">
                <div className={`text-lg font-black ${
                  callExamples[currentCallType].color === 'red' ? 'text-red-600' :
                  callExamples[currentCallType].color === 'green' ? 'text-green-600' : 'text-blue-600'
                }`}>{callExamples[currentCallType].outcome}</div>
                <div className="text-xs text-gray-500">Handled automatically</div>
              </div>

              {/* Call type indicators */}
              <div className="flex justify-center gap-2 mt-6">
                {callExamples.map((_, index) => (
                  <div 
                    key={index}
                    className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                      currentCallType === index ? 'bg-blue-600' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-black mb-6 text-gray-900">
              Every Missed Call is Lost Revenue
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl font-black text-red-600 mb-2">68%</div>
              <div className="text-gray-700 font-semibold mb-2">of landscaping calls go unanswered</div>
              <div className="text-sm text-gray-600">Busy season calls especially can't wait</div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl font-black text-red-600 mb-2">$385</div>
              <div className="text-gray-700 font-semibold mb-2">average project value</div>
              <div className="text-sm text-gray-600">Maintenance, design, and installation work</div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl font-black text-red-600 mb-2">$31K</div>
              <div className="text-gray-700 font-semibold mb-2">annual revenue lost per landscaper</div>
              <div className="text-sm text-gray-600">From missed calls across all service types</div>
            </div>
          </div>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-xl max-w-3xl mx-auto">
            <div className="font-bold text-blue-700 mb-2 flex items-center gap-2">
              <MaterialIcon name="checkCircle" className="w-5 h-5" />
              The Solution
            </div>
            <div className="text-blue-800">
              AI receptionist that knows landscaping inside and out. Handles maintenance scheduling, quotes design projects, 
              books consultations, and captures every lead. Your calendar stays full while you focus on the work.
            </div>
          </div>
        </div>
      </section>

      {/* Services We Handle */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
            Every Type of <span className="text-blue-900">Landscaping Call</span>
          </h2>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Maintenance Services */}
            <div className="bg-blue-50 rounded-3xl p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
                <MaterialIcon name="grass" className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-black mb-4 text-gray-900">Maintenance Services</h3>
              <ul className="space-y-2 text-gray-700 mb-6">
                <li>• Weekly lawn mowing & edging</li>
                <li>• Fertilization & weed control</li>
                <li>• Seasonal cleanups</li>
                <li>• Hedge trimming & pruning</li>
                <li>• Irrigation system maintenance</li>
              </ul>
              <div className="text-sm text-blue-700 font-semibold">
                AI books recurring appointments and explains seasonal needs
              </div>
            </div>

            {/* Design & Installation */}
            <div className="bg-green-50 rounded-3xl p-8">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                <MaterialIcon name="park" className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-xl font-black mb-4 text-gray-900">Design & Installation</h3>
              <ul className="space-y-2 text-gray-700 mb-6">
                <li>• Landscape design consultation</li>
                <li>• Plant selection & installation</li>
                <li>• Hardscape & patio installation</li>
                <li>• Garden bed creation</li>
                <li>• Outdoor lighting systems</li>
              </ul>
              <div className="text-sm text-green-700 font-semibold">
                Schedules design consultations and provides project estimates
              </div>
            </div>

            {/* Specialized Services */}
            <div className="bg-red-50 rounded-3xl p-8">
              <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
                <MaterialIcon name="build" className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="text-xl font-black mb-4 text-gray-900">Specialized Services</h3>
              <ul className="space-y-2 text-gray-700 mb-6">
                <li>• Tree removal & stump grinding</li>
                <li>• Sprinkler system installation</li>
                <li>• Sod installation & seeding</li>
                <li>• Mulching & soil amendment</li>
                <li>• Storm cleanup & restoration</li>
              </ul>
              <div className="text-sm text-red-700 font-semibold">
                Handles urgent requests and schedules specialized work
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-black mb-12 text-gray-900">
            Landscapers Love Their AI Receptionist
          </h2>
          
          <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-white font-bold text-xl">{testimonials[0].author[0]}</span>
            </div>
            <div className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 leading-relaxed">
              "{testimonials[0].quote}"
            </div>
            <div className="text-blue-900 font-semibold">{testimonials[0].author}</div>
            <div className="text-gray-600">{testimonials[0].business}</div>
            <div className="text-green-600 font-bold mt-2">{testimonials[0].result}</div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6">
            {testimonials.slice(1).map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg">
                <div className="text-lg font-bold text-gray-900 mb-3">
                  "{testimonial.quote}"
                </div>
                <div className="text-blue-900 font-semibold">{testimonial.author}</div>
                <div className="text-gray-600 text-sm">{testimonial.business}</div>
                <div className="text-green-600 font-bold text-sm mt-1">{testimonial.result}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-16 px-6 bg-blue-900 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-black mb-8">
            One Design Project Pays for Everything
          </h2>
          
          <div className="bg-white/10 rounded-3xl p-8 mb-8">
            <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
            <div className="text-xl text-blue-100 mb-6">per month • unlimited calls • all services</div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left mb-8">
              <div className="flex items-center gap-3">
                <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-400" />
                <span className="text-blue-100">Maintenance scheduling</span>
              </div>
              <div className="flex items-center gap-3">
                <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-400" />
                <span className="text-blue-100">Design consultation booking</span>
              </div>
              <div className="flex items-center gap-3">
                <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-400" />
                <span className="text-blue-100">Installation project quotes</span>
              </div>
              <div className="flex items-center gap-3">
                <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-400" />
                <span className="text-blue-100">Landscaping-specific training</span>
              </div>
              <div className="flex items-center gap-3">
                <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-400" />
                <span className="text-blue-100">Complete call summaries</span>
              </div>
              <div className="flex items-center gap-3">
                <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-400" />
                <span className="text-blue-100">Calendar integration</span>
              </div>
            </div>
            
            <button 
              onClick={() => setShowWaitlistModal(true)}
              className="w-full bg-white text-blue-900 hover:bg-blue-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              Get My Landscaping AI →
            </button>
          </div>
          
          <p className="text-blue-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-6 bg-gray-900 text-white text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl lg:text-5xl font-black mb-6">
            Your Schedule. Always Full.
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            From morning maintenance to design consultations, 
            your AI receptionist keeps the work flowing.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setShowWaitlistModal(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              Start Getting More Calls
            </button>
            
            <a
              href="tel:+17863845350"
              className="bg-white text-gray-900 hover:bg-gray-100 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              Test It Live Right Now
            </a>
          </div>
        </div>
      </section>

      {/* Waitlist Modal */}
      <Modal
        isOpen={showWaitlistModal}
        onClose={() => setShowWaitlistModal(false)}
        title="Get Your Landscaping AI"
      >
        {waitlistSuccess ? (
          <div className="text-center">
            <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
            <p className="text-gray-600">We'll have your landscaping AI ready within 24 hours of launch.</p>
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
              <input
                type="text"
                required
                value={waitlistData.name}
                onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="e.g. Carlos Delgado"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
              <input
                type="email"
                required
                value={waitlistData.email}
                onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="carlos@verdelandscaping.com"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
              <input
                type="tel"
                required
                value={waitlistData.phone}
                onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="(555) 123-4567"
              />
            </div>
            
            <button
              onClick={handleWaitlistSubmit}
              disabled={waitlistLoading}
              className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Landscaping AI'}
            </button>
            
            <p className="text-xs text-gray-500 text-center">
              Complete setup in 24 hours • Handles all types of landscaping calls
            </p>
          </div>
        )}
      </Modal>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8 px-6">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-lg font-black text-blue-900">
            <a href="/">receptioneer.ai</a>
          </div>
          <div className="flex gap-6 text-sm text-gray-600">
            <a href="/privacy" className="hover:text-blue-900">Privacy</a>
            <a href="/terms" className="hover:text-blue-900">Terms</a>
            <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandscapersLanding;